<template>
  <div class="form-container card shadow-sm p-3">
    <!-- Cabeçalho -->
    <div class="header d-flex justify-content-between align-items-center">
      <h4 class="form-title">
        {{ isEditing ? "Editar Recesso nº" : "Novo Recesso" }}
        <span v-if="isEditing">{{ recessoId }}</span>
      </h4>
      <button class="btn btn-secondary" @click="cancelar">Voltar</button>
    </div>

    <div class="spacer"></div>

    <!-- Formulário -->
    <b-form @submit.prevent="submitFormulario">
      <!-- Seção: Dados do Recesso -->
      <div class="form-section">
        <div class="form-group mt-3">
          <label for="descricao">Descrição <span class="required">*</span></label>
          <textarea
            id="descricao"
            class="form-control"
            v-model="descricao"
            rows="2"
            placeholder="Descreva o período de recesso"
            required
          ></textarea>
        </div>

        <div class="row">
          <div class="col-md-3 form-group">
            <label for="dataInicio">Início <span class="required">*</span></label>
            <input
              type="date"
              id="dataInicio"
              class="form-control"
              v-model="dataInicio"
              required
            />
          </div>
          <div class="col-md-3 form-group">
            <label for="dataFim">Fim <span class="required">*</span></label>
            <input
              type="date"
              id="dataFim"
              class="form-control"
              v-model="dataFim"
              required
            />
          </div>
        </div>
        <p class="recesso-info">
        1. Os planos com final da vigência prevista para após a data de fim, terão os dias de recesso adicionados à vigência.
        </p>
        <p class="recesso-info">
        2. Os planos com final da vigência prevista para o período do recesso, terão os dias proporcionais adicionados à vigência.
        </p>
        <!-- <div class="cadastrado-por">
            Cadastrado por {{por}}
        </div> -->
        <!-- <div class="form-check mt-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="aplicado"
            v-model="aplicado"
          />
          <label class="form-check-label" for="aplicado">
            Aplicado
          </label>
        </div> -->
      </div>

      <!-- Botões de Ação -->
      <div class="form-actions d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn-primary me-2"
          :disabled="!formValid || isSubmitting"
        >
          <i :class="isSubmitting ? 'bi bi-hourglass-split me-1' : 'bi bi-save me-1'"></i>
          {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          @click="cancelar"
          :disabled="isSubmitting"
        >
          <i class="bi bi-x-circle me-1"></i>Cancelar
        </button>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { BForm } from 'bootstrap-vue-next'
import axios from '@/services/axios'

const route = useRoute()
const router = useRouter()

const { appContext } = getCurrentInstance()
const userName = appContext.config.globalProperties.$globalState.userName

const recessoId = ref(null)
const isEditing = ref(false)

const dataInicio  = ref('')
const dataFim     = ref('')
const descricao   = ref('')
const aplicado    = ref(false)
const por         = ref(userName)

const isSubmitting = ref(false)

const formValid = computed(() => {
  return dataInicio.value && dataFim.value && descricao.value.trim()
})

const cancelar = () => { if (!isSubmitting.value) router.push('/configuracoes/recessos') }

function formatDateForInput(dateStr) {
  return dateStr ? new Date(dateStr).toISOString().slice(0, 10) : ''
}

async function carregarRecesso(id) {
  try {
    const { data } = await axios.get(`/configuracoes/recessos/${id}`)
    recessoId.value = data.id
    dataInicio.value = formatDateForInput(data.data_inicio)
    dataFim.value    = formatDateForInput(data.data_fim)
    descricao.value  = data.descricao
    aplicado.value   = data.aplicado
    // mantém o usuário logado em 'por'
  } catch (err) {
    console.error('Erro ao carregar recesso:', err)
  }
}

async function submitFormulario() {
  if (isSubmitting.value || !formValid.value) return
  isSubmitting.value = true
  const payload = {
    data_inicio: dataInicio.value,
    data_fim:    dataFim.value,
    descricao:   descricao.value.trim(),
    aplicado:    aplicado.value,
    por:         por.value
  }
  try {
    if (isEditing.value) {
      await axios.put(`/configuracoes/recessos/${recessoId.value}`, payload)
    } else {
      await axios.post('/configuracoes/recessos', payload)
    }
    router.push('/configuracoes/recessos')
  } catch (err) {
    console.error('Erro ao salvar recesso:', err)
  } finally {
    isSubmitting.value = false
  }
}

onMounted(async () => {
  if (route.params.id) {
    isEditing.value = true
    await carregarRecesso(route.params.id)
  }
})
</script>

<style scoped>
.form-container {
  margin: 20px auto;
  width: 90%;
}
.header {
  margin-bottom: 10px;
}
.form-title {
  font-size: 1.25rem;
  font-weight: bold;
}
.spacer {
  margin-bottom: 20px;
}
.form-section {
  background: white;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}
.form-group {
  margin-bottom: 1rem;
}
.form-actions {
  margin-top: 20px;
}
.required {
  color: red;
}
.recesso-info {
  color: #1334ca;      /* azul padrão Bootstrap */
  font-size: 0.75rem;   /* tamanho um pouco menor */
  font-style: italic;  /* itálico */
  line-height: 0.5;     /* controla o espaçamento entre linhas (padrão é em torno de 1.5) */
}

</style>
